import React from 'react';
import './GeneralDocs.css'; 
import standbyImage from '../assets/standby.png';
import offImage from '../assets/off.png';


const Modes = () => {
  return (
    <div className="docs-page-container">
      <h1>What is a Mode?</h1>
      <p>
        A Mode is a set of instructions grouped together. Modes are created so the user can have a set of specific instructions for a specific need.
        Besides user specific Modes, FaceLead comes with 3 built-in Modes: Off, StandBy and SplitLead.
      </p>

      <h2>Off and StandBy logic</h2>
      <p>
        The app always starts in Off Mode. This mode is only meant to run one Instruction: switch to StandBy mode.
        A good way to understand Off Mode is as a mode that waits for a password to start using the app.
        An input with multiple gestures is recommended in order to avoid unwanted triggers.
      </p>
      <img src={offImage} alt="Off mode with a strong password" className="mode-image" />
      <p>StandBy mode is meant be the navigator to the different user modes.</p>
      <img src={standbyImage} alt="StandBy mode with different modes" className="mode-image" />
      <p>
        In order to go back to StandBy or Off, you can set an Instruction to switch modes or close your eyes for a couple seconds. 
        Closing your eyes will first send you to StandBy and then (if the eyes remain closed) to Off. 
      </p>

      <h2>Custom Modes Examples</h2>
      <p>You can create your own modes to suit your specific needs. To see some examples, go to <a href="/docs/modes/gestures">gestures examples</a> or <a href="/docs/modes/blinks">blinks examples</a>
      </p>

    </div>
  );
};

export default Modes;
